import _ from "lodash";
import BaseApiModel from "scripts/models/baseApiModel";
import RedirectException from "scripts/exceptions/redirectException";

import fallBackImageAnthology from "images/fallbacks/fallback_160_160.png";
import thumbnailFallbackUrl from "images/fallbacks/fallback_380_380.png";

class AnthologyModel extends BaseApiModel {
  urlRoot() {
    return `${this.apiUrlRoot}/anthologies/`;
  }

  parse(response) {
    // redirect deleted anthologies that have been converted to modules or collections
    if (response && response.redirectTo) {
      throw new RedirectException(response.redirectTo);
    }

    response.iconFallbackUrl = fallBackImageAnthology;
    response.thumbnailFallbackUrl = thumbnailFallbackUrl;

    response.typeLabelLowerCase = response.typeLabel.toLowerCase();

    if (response.typeCode === "ANTHOLOGY") {
      response.collectionTypeCode = "COLLECTION";
      response.collectionTypeLabel = "Collection";
    } else {
      response.collectionTypeCode = "CHAPTER";
      response.collectionTypeLabel = "Chapter";
    }

    response.collectionTypeLabelLowerCase = response.collectionTypeLabel.toLowerCase();

    response.whiteMediaBadges = _.filter(response.mediaBadges, {
      type: "white",
    });
    response.blackMediaBadges = _.filter(response.mediaBadges, {
      type: "black",
    });

    return response;
  }

  toJSON() {
    let attributes = _.clone(this.attributes); //TODO: why not call super?
    attributes.shortDescription = this.getShortDescription();
    return attributes;
  }

  getShortDescription() {
    return _.prune(this.get("description"), 255);
  }
}

export default AnthologyModel;
